document.addEventListener('DOMContentLoaded', () => {
  // Different form structures used throughout the application
  const selectors = [
    // exhibitor/application/_form.html.haml
    '#exhibitor_application_bipoc',
    // profiles/edit_exhibitor_profile.html.haml
    '#exhibitor_profile_bipoc',
    // exhibitor/dashboard/shares/_exhibitor_application_form.html.haml
    '#exhibitor_application_exhibitor_attributes_profiles_attributes_0_exhibitor_profile_attributes_bipoc',
    // exhibitor/application/profile/edit.html.haml
    '#profile_exhibitor_profile_attributes_bipoc'
  ];

  const bipocDetails = document.querySelector('.bipoc_details');

  // Handle all matching checkboxes
  selectors.forEach(selector => {
    const checkbox = document.querySelector(selector);
    if (checkbox) {
      checkbox.addEventListener('click', function(e) {
        if (this.checked) {
          bipocDetails.style.display = '';
        } else {
          // Find the corresponding details field
          const detailsSelectors = [
            '#exhibitor_application_bipoc_details',
            '#exhibitor_profile_bipoc_details',
            '#exhibitor_application_exhibitor_attributes_profiles_attributes_0_exhibitor_profile_attributes_bipoc_details',
            '#profile_exhibitor_profile_attributes_bipoc_details'
          ];

          const detailsField = detailsSelectors.find(selector => document.querySelector(selector));
          if (detailsField) {
            document.querySelector(detailsField).value = '';
          }
          bipocDetails.style.display = 'none';
        }
      });
    }
  });
});

